(function(){
  var bar = document.getElementById('pulselife-progress');
  if(!bar) return;
  window.addEventListener('scroll', function(){
    var h = document.documentElement;
    var scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight) * 100;
    bar.style.width = scrolled + '%';
  }, {passive:true});
})();